import React, { useState } from 'react';
import { Users2, Building2, ChevronDown, Search, Filter } from 'lucide-react';
import { useDeals } from '../../store/DealsContext';
import StakeholderList from './StakeholderList';
import StakeholderForm from './StakeholderForm';
import StakeholderMetrics from './StakeholderMetrics';

export default function StakeholderManager() {
  const { deals } = useDeals();
  const [selectedDeal, setSelectedDeal] = useState<string>('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState<string>('');

  return (
    <div className="h-full space-y-6">
      <div className="flex justify-between items-start">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Stakeholder Management</h2>
          <p className="mt-2 text-gray-600">Track and manage key stakeholders</p>
        </div>
        
        <div className="flex items-center space-x-4">
          <select
            value={selectedDeal}
            onChange={(e) => setSelectedDeal(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Deals</option>
            {deals.map((deal) => (
              <option key={deal.id} value={deal.id}>{deal.name}</option>
            ))}
          </select>

          <button
            onClick={() => setShowAddForm(true)}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
          >
            Add Stakeholder
          </button>
        </div>
      </div>

      <StakeholderMetrics dealId={selectedDeal} />

      <div className="bg-white rounded-lg shadow-sm">
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center space-x-4">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search stakeholders..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">All Types</option>
              <option value="internal">Internal</option>
              <option value="external">External</option>
              <option value="board">Board Member</option>
              <option value="advisor">Advisor</option>
            </select>
          </div>
        </div>

        <StakeholderList
          dealId={selectedDeal}
          searchTerm={searchTerm}
          filterType={filterType}
        />
      </div>

      {showAddForm && (
        <StakeholderForm
          onClose={() => setShowAddForm(false)}
          dealId={selectedDeal}
        />
      )}
    </div>
  );
}